import type { FC, HTMLAttributes, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

interface CardsSectionProps extends Omit<HTMLAttributes<HTMLDivElement>, `title`> {
  isEmpty?: boolean
}

const CardsSection: FC<PropsWithChildren<CardsSectionProps>> = ({ children, ...rest }) => {
  return (
    <StyledSectionBase variant="noCopy" {...rest}>
      <Section.Contents>{children}</Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)<Omit<CardsSectionProps, `title`>>`
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      ${Section.Wrapper} {
        padding-top: 40px;
        padding-bottom: 40px;
      }
    `}
`

export default CardsSection
